var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpskillingIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_4017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5311 3.74939H15.0182L10.1483 2.02458C10.0498 1.98971 9.94314 1.99054 9.84512 2.02697L5.21347 3.74939H2.46886C2.20992 3.74939 2 3.97243 2 4.24755V15.5004C2 15.7755 2.20992 15.9986 2.46886 15.9986H6.70695V17.0026H5.29302C5.03409 17.0026 4.82416 17.2257 4.82416 17.5008C4.82416 17.7759 5.03409 17.999 5.29302 17.999H14.707C14.9659 17.999 15.1758 17.7759 15.1758 17.5008C15.1758 17.2257 14.9659 17.0026 14.707 17.0026H13.2931V15.9985H17.5311C17.7901 15.9985 18 15.7755 18 15.5004V4.24755C18 3.9724 17.7901 3.74939 17.5311 3.74939ZM7.40939 5.56241C9.92086 6.49852 9.88607 6.49616 10 6.49616C10.1086 6.49616 10.0738 6.49852 12.5906 5.60561V6.90615L10 7.96492L7.40939 6.90615V5.56241ZM10.0037 3.0236L13.4597 4.24759L10.0037 5.47157L6.71229 4.24759L10.0037 3.0236ZM12.3553 17.0026H7.64467V15.9985H12.3553V17.0026H12.3553ZM17.0623 15.0022C14.9958 15.0022 6.05961 15.0022 2.93772 15.0022V4.74572H5.21316L6.47167 5.21372V7.24829C6.47167 7.4544 6.59114 7.63925 6.77221 7.71324C9.90091 8.99502 9.87557 8.99685 10 8.99685C10.1244 8.99685 10.1004 8.99784 13.2278 7.71324C13.4089 7.63925 13.5283 7.4544 13.5283 7.24829V5.2735L14.4735 4.93874V7.74845C14.4735 8.02357 14.6835 8.24661 14.9424 8.24661C15.2013 8.24661 15.4113 8.02357 15.4113 7.74845V4.74572H17.0623V15.0022Z",
    fill: "#494949",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23446 10.502H4.35167C4.09274 10.502 3.88281 10.725 3.88281 11.0001V13.0006C3.88281 13.2757 4.09274 13.4987 4.35167 13.4987H6.23446C6.49339 13.4987 6.70332 13.2757 6.70332 13.0006V11.0001C6.70332 10.725 6.49339 10.502 6.23446 10.502ZM5.7656 12.5024H4.82053V11.4983H5.7656V12.5024Z",
    fill: "#494949",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1173 10.502C7.85836 10.502 7.64844 10.725 7.64844 11.0001C7.64844 11.2752 7.85836 11.4983 8.1173 11.4983H15.6485C15.9074 11.4983 16.1173 11.2752 16.1173 11.0001C16.1173 10.725 15.9074 10.502 15.6485 10.502H8.1173Z",
    fill: "#494949",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6485 12.501H8.1173C7.85836 12.501 7.64844 12.724 7.64844 12.9991C7.64844 13.2743 7.85836 13.4973 8.1173 13.4973H15.6485C15.9074 13.4973 16.1173 13.2743 16.1173 12.9991C16.1173 12.724 15.9074 12.501 15.6485 12.501Z",
    fill: "#494949",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_4017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "translate(2 1.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpskillingIconGrey);
export default __webpack_public_path__ + "static/media/upskilling_icon_grey.6b449e15d5028fd79922407ad151c37a.svg";
export { ForwardRef as ReactComponent };